import { useEffect, useCallback } from 'react';
import { useAppState } from './app-state';
import { AvailabilityStatus } from '../types/availability-status';
import { useTexts } from './editor-settings';

export const useAwayMessageHandler = (userId: string) => {
  const {
    appState: {
      availabilityStatus,
      isContact,
      chatroomId,
      hasMessages,
      wasAwayMessageSent,
    },
    updateAppState,
  } = useAppState();
  const { offlineChatMessage } = useTexts();
  const setAwayMessageSent = useCallback(
    () => updateAppState({ hasMessages: true }),
    [],
  );
  useEffect(() => {
    if (
      !wasAwayMessageSent &&
      availabilityStatus === AvailabilityStatus.Away &&
      isContact &&
      !hasMessages &&
      offlineChatMessage
    ) {
      void (async () => {
        const { chatSdk, Message } = await import(
          /* webpackChunkName: "chat-sdk" */ '@wix/chat-sdk'
        );
        const messageDto = Message.fromText({
          text: offlineChatMessage,
          chatroomId: chatroomId || '',
          userId,
          summary: offlineChatMessage,
        });
        void chatSdk.addMessage(messageDto);
      })();
      setAwayMessageSent();
    }
  }, [
    wasAwayMessageSent,
    availabilityStatus,
    isContact,
    offlineChatMessage,
    hasMessages,
  ]);
};
